import React from 'react';

function GatewayClinicInfoText({clinicInfo}) {
    if (!clinicInfo) return null;

    return (
        <div className="card shadow-none">
            <div className="card-body">
                <div className="row g-4">
                    {/* Basic Information Section */}
                    <div className="col-12">
                        <div className="card-title fw-bold mb-3 text-primary">
                            <i className="bi bi-info-circle me-2"></i> Basic Information
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="d-flex align-items-center mb-3">
                            <i className="bi bi-building me-3 fs-4 text-muted"></i>
                            <div>
                                <h6 className="mb-0 text-muted">Name</h6>
                                <p className="mb-0 fw-normal">{clinicInfo.name || '-'}</p>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="d-flex align-items-center mb-3">
                            <i className="bi bi-envelope me-3 fs-4 text-muted"></i>
                            <div>
                                <h6 className="mb-0 text-muted">Email</h6>
                                <p className="mb-0 fw-normal">{clinicInfo.email || '-'}</p>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="d-flex align-items-center mb-3">
                            <i className="bi bi-telephone me-3 fs-4 text-muted"></i>
                            <div>
                                <h6 className="mb-0 text-muted">Phone</h6>
                                <p className="mb-0 fw-normal">{clinicInfo.phone || '-'}</p>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="d-flex align-items-center mb-3">
                            <i className="bi bi-chat-left-text me-3 fs-4 text-muted"></i>
                            <div>
                                <h6 className="mb-0 text-muted">SMS</h6>
                                <p className="mb-0 fw-normal">{clinicInfo.sms || '-'}</p>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="d-flex align-items-center mb-3">
                            <i className="bi bi-pen me-3 fs-4 text-muted"></i>
                            <div>
                                <h6 className="mb-0 text-muted">Signature</h6>
                                <p className="mb-0 fw-normal">{clinicInfo.signature || '-'}</p>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="d-flex align-items-center mb-3">
                            <i className="bi bi-globe me-3 fs-4 text-muted"></i>
                            <div>
                                <h6 className="mb-0 text-muted">Website</h6>
                                <p className="mb-0 fw-normal">
                                    {clinicInfo.website ? (
                                        <a href={clinicInfo.website} target="_blank" rel="noopener noreferrer">
                                            {clinicInfo.website}
                                        </a>
                                    ) : '-'}
                                </p>
                            </div>
                        </div>
                    </div>
                    <hr/>
                    {/* Address Section */}
                    <div className="col-12 mt-4">
                        <div className="card-title fw-bold mb-3 text-primary">
                            <i className="bi bi-geo-alt me-2"></i> Address Information
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="d-flex align-items-center mb-3">
                            <i className="bi bi-signpost me-3 fs-4 text-muted"></i>
                            <div>
                                <h6 className="mb-0 text-muted">Street</h6>
                                <p className="mb-0 fw-normal">{clinicInfo.street || '-'}</p>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="d-flex align-items-center mb-3">
                            <i className="bi bi-building me-3 fs-4 text-muted"></i>
                            <div>
                                <h6 className="mb-0 text-muted">City</h6>
                                <p className="mb-0 fw-normal">{clinicInfo.city || '-'}</p>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="d-flex align-items-center mb-3">
                            <i className="bi bi-mailbox me-3 fs-4 text-muted"></i>
                            <div>
                                <h6 className="mb-0 text-muted">Postal Code</h6>
                                <p className="mb-0 fw-normal">{clinicInfo.postalCode || '-'}</p>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="d-flex align-items-center mb-3">
                            <i className="bi bi-map me-3 fs-4 text-muted"></i>
                            <div>
                                <h6 className="mb-0 text-muted">Province</h6>
                                <p className="mb-0 fw-normal">{clinicInfo.province || '-'}</p>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="d-flex align-items-center mb-3">
                            <i className="bi bi-globe2 me-3 fs-4 text-muted"></i>
                            <div>
                                <h6 className="mb-0 text-muted">Country</h6>
                                <p className="mb-0 fw-normal">{clinicInfo.country || '-'}</p>
                            </div>
                        </div>
                    </div>

                    <hr/>
                    {/* Verification Section */}
                    <div className="col-12 mt-4">
                        <div className="card-title fw-bold mb-3 text-primary">
                            <i className="bi bi-shield-check me-2"></i> Verification Status
                        </div>
                    </div>

                    <div className="col-md-4">
                        <div className="d-flex align-items-center mb-3">
                            <i className={`bi ${clinicInfo.isEmailVerified ? 'bi-check-circle-fill text-success' : 'bi-x-circle-fill text-danger'} me-3 fs-4`}></i>
                            <div>
                                <h6 className="mb-0 text-muted">Email Verified</h6>
                                <p className="mb-0 fw-bold">{clinicInfo.isEmailVerified ? 'Yes' : 'No'}</p>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-4">
                        <div className="d-flex align-items-center mb-3">
                            <i className={`bi ${clinicInfo.isSmsVerified ? 'bi-check-circle-fill text-success' : 'bi-x-circle-fill text-danger'} me-3 fs-4`}></i>
                            <div>
                                <h6 className="mb-0 text-muted">SMS Verified</h6>
                                <p className="mb-0 fw-bold">{clinicInfo.isSmsVerified ? 'Yes' : 'No'}</p>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-4">
                        <div className="d-flex align-items-center mb-3">
                            <i className={`bi ${clinicInfo.isPhoneVerified ? 'bi-check-circle-fill text-success' : 'bi-x-circle-fill text-danger'} me-3 fs-4`}></i>
                            <div>
                                <h6 className="mb-0 text-muted">Phone Verified</h6>
                                <p className="mb-0 fw-bold">{clinicInfo.isPhoneVerified ? 'Yes' : 'No'}</p>
                            </div>
                        </div>
                    </div>

                    <hr/>
                    {/* Timezone */}
                    <div className="col-md-6">
                        <div className="d-flex align-items-center mb-3 p-2">
                            <i className="bi bi-clock me-3 fs-4 text-muted"></i>
                            <div>
                                <h6 className="mb-0 text-muted">Timezone</h6>
                                <p className="mb-0 fw-normal">{clinicInfo.timezone || '-'}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default GatewayClinicInfoText;